export default __webpack_public_path__ + "static/media/nov-dec.79c6bc8f.mp3";